import WebLayout from "../layout/WebLayout";

function About() {
  return (
    <WebLayout pageName={About}>
      <div className="product-dContent__box">
        <div className="tab-content" id="pills-tabContent">
          <div
            className="tab-pane fade show active"
            id="pills-description"
            role="tabpanel"
            aria-labelledby="pills-description-tab"
            tabIndex="0"
          >
            <div className="mb-20">
              <h6 className="mb-10">Background</h6>
              <p className="mb-2">
                IndianMSME.org is an initiative by ASC Distributor Private
                Limited, inspired by the operational success and growing demand
                of the Ardh Sainik Canteen (ASC) by the Soldiers. The ASC, under
                the aegis of the Ardh Sainik Welfare Trust (ASWT), has been
                instrumental in providing quality goods at affordable prices to
                society through a network of retail outlets across India.
              </p>
              <p className="mb-2">
                The overwhelming response to the ASC model is evidenced by over
                6,063 registrations, with the demand expected to reach 20,000
                registrations soon.
              </p>
              <p className="mb-2">
                Additionally, the existing 86 DDCs are set to expand to 800
                DDCs, aiming for a “One District – One Ardh Sainik Mall” model
                to ensure comprehensive district-level reach and efficiency.
                (Ref www.ardhsainikcanteen.com):
              </p>
              <h6 className="mt-10 mb-10">Key Objectives of IndianMSME.org:</h6>
              <ol style={{ listStyle: "decimal", paddingLeft: "20px" }}>
                <li>
                  Establishment of Ardh Sainik Malls (DDC) (Distribution and
                  Display Centres):
                  <ul className="list-inside mt-10 ms-16">
                    <li className="text-gray-400 mb-4">
                      We propose the creation of Ardh Sainik Malls (DDC) in each
                      district, functioning as District Distribution and Display
                      Centres (DDCs) for MSME Manufacturers. These centres will
                      serve multiple purposes:
                      <ul className="list-inside mt-10 ms-16">
                        <li className="text-gray-400 mb-4">
                          Display and Distribution Hubs: Providing MSME
                          manufacturers with dedicated spaces to showcase and
                          distribute their products.
                        </li>
                        <li className="text-gray-400 mb-4">
                          Retail and Wholesale Outlets: Catering to the general
                          public's needs by offering a wide range of products at
                          competitive prices.
                        </li>
                        <li className="text-gray-400 mb-4">
                          ASC Retails chain: Considering the Ardh Sainik Canteen
                          pending applications to start retails immediately.
                        </li>
                      </ul>
                    </li>
                  </ul>
                </li>
                <li>
                  Empowerment of MSME Manufacturers:
                  <ul className="list-inside mt-10 ms-16">
                    <li className="text-gray-400 mb-4">
                      Enable a robust B2B and B2C ecosystem.
                    </li>
                    <li className="text-gray-400 mb-4">
                      Provide display, logistics, and digital marketing support
                      to ensure wider visibility and streamlined operations for
                      MSMEs.
                    </li>
                    <li className="text-gray-400 mb-4">
                      By offering a structured platform for product display and
                      sales, MSME manufacturers can expand their market reach,
                      increase visibility, and boost sales.
                    </li>
                  </ul>
                </li>
                <li>
                  Economic Growth and Employment Generation:
                  <ul className="list-inside mt-10 ms-16">
                    <li className="text-gray-400 mb-4">
                      The initiative is poised to stimulate local economies by
                      creating employment opportunities and fostering a culture
                      of entrepreneurship.
                    </li>
                  </ul>
                </li>
                <li>
                  Payment Solutions:
                  <ul className="list-inside mt-10 ms-16">
                    <li className="text-gray-400 mb-4">
                      Facilitating secure and timely payments between buyers and
                      sellers, where IndianMSME.org assumes responsibility for
                      payment collection, ensuring smooth and secure
                      transactions.
                    </li>
                  </ul>
                </li>
                <li>
                  Facilitation of Pending Applications:
                  <ul className="list-inside mt-10 ms-16">
                    <li className="text-gray-400 mb-4">
                      By integrating the pending applications into the
                      IndianMSME.org platform, we aim to expedite the process of
                      establishing new outlets, thereby promoting
                      entrepreneurship and self-reliance among applicants.
                    </li>
                  </ul>
                </li>
              </ol>
              <p>
                IndianMSME.org is committed to building upon the foundation laid
                by the Ardh Sainik Canteen, extending its benefits to a wider
                audience, and contributing to the nation's economic development.
              </p>
            </div>

            <div className="mb-20">
              <h6 className="mb-10">Vision of IndianMSME.org</h6>
              <ul className="mt-20">
                <li className="text-gray-400 mb-14 flex-align gap-14">
                  <span className="w-20 h-20 bg-main-50 text-main-600 text-xs flex-center rounded-circle">
                    <i className="ph ph-check"></i>
                  </span>
                  <span className="text-heading fw-medium">
                    To uphold the spirit of "Aatmanirbhar Bharat" by providing
                    MSME manufacturers with a platform to showcase their Made in
                    India products.
                  </span>
                </li>
                <li className="text-gray-400 mb-14 flex-align gap-14">
                  <span className="w-20 h-20 bg-main-50 text-main-600 text-xs flex-center rounded-circle">
                    <i className="ph ph-check"></i>
                  </span>
                  <span className="text-heading fw-medium">
                    To create a self-sufficient ecosystem for MSMEs by combining
                    the strengths of digital technology, physical distribution
                    centres, and dedicated vendor support.
                  </span>
                </li>
                <li className="text-gray-400 mb-14 flex-align gap-14">
                  <span className="w-20 h-20 bg-main-50 text-main-600 text-xs flex-center rounded-circle">
                    <i className="ph ph-check"></i>
                  </span>
                  <span className="text-heading fw-medium">
                    To amplify the reach of MSME products across every district
                    in India, fostering economic growth and employment
                  </span>
                </li>
              </ul>
            </div>
            <div className="mb-0">
              <h6 className="mb-10">Mission of IndianMSME.org</h6>
              <ul className="mt-20">
                <li className="text-gray-400 mb-14 flex-align gap-14">
                  <span className="w-20 h-20 bg-main-50 text-main-600 text-xs flex-center rounded-circle">
                    <i className="ph ph-check"></i>
                  </span>
                  <span className="text-heading fw-medium">
                    To support and empower MSME manufacturers with the necessary
                    infrastructure and tools to compete in both domestic and
                    international markets.
                  </span>
                </li>
                <li className="text-gray-400 mb-14 flex-align gap-14">
                  <span className="w-20 h-20 bg-main-50 text-main-600 text-xs flex-center rounded-circle">
                    <i className="ph ph-check"></i>
                  </span>
                  <span className="text-heading fw-medium">
                    To expand and scale the operational model of Ardh Sainik
                    Canteen.
                  </span>
                </li>
              </ul>
            </div>
          </div>
        </div>
      </div>
    </WebLayout>
  );
}

export default About;
